import { projectSortOptions } from "authoring/lib/constants/project-sort-options"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { StandardSelector } from "lib/@components/combos/standard-selector"

export function ProjectSortSelector() {
    const { sort, setSort } = useBoundContext()
    return (
        <StandardSelector
            options={projectSortOptions}
            onChange={setSort}
            value={sort}
            sortTitle={"Sort: "}
            sx={{ color: "inherit", fontWeight: "light" }}
            size={"large"}
            data-cy="authoring-project-sort"
        />
    )
}
